// EventForm.tsx
import React, { useState, useEffect } from 'react';
import {
    Box,
    TextField,
    Typography,
    Stack,
    CircularProgress,
    Button,
} from '@mui/material';
import { EventImage, EventRecord } from '../../../types/event';
import { useFetch } from '../../../hooks/useFetch2';
import { api } from '../../../api/eventApi';
import { useTranslation } from 'react-i18next';
import { formatDateTime } from '../../../tools/util';

export interface EventFormProps {
    eventRecord?: EventRecord;
    onCancel: () => void;
}

const EventForm: React.FC<EventFormProps> = ({
    eventRecord,
    onCancel,
}) => {
    const { t } = useTranslation();
    const title = t('EventForm.title');

    // 1. Создаем объект параметров с помощью useMemo
    const fetchParams = React.useMemo(() => ({
        origin_id: eventRecord?.entity_id,
        uuid: eventRecord?.uuid,
    }), [eventRecord?.entity_id, eventRecord?.uuid]); // Зависит только от ID и UUID

    const { data, error, loading, } = useFetch<EventImage>(api.getImage, { 
        object: '',  
        background: '', 
        origin_name: '', 
        result: false,
        ts_start: '2000-01-01', 
      }, {
        origin_id: eventRecord?.entity_id,
        uuid: eventRecord?.uuid,
    });

    console.log('loading',loading,'data',data);

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
                <CircularProgress />
            </Box>
        );
    }
    if (!data) {
        return <Typography color="info">{t('no data')}</Typography>;
    }
    
    // ПРОВЕРКА НА ОШИБКУ
    if (error) {
        return <Typography color="error">{t('EventForm.error')}: {error.message}</Typography>;
    }

    // console.log('data', data);
    const objectSrc = `data:image/jpeg;base64,${data.object}`;
  
    const hasBackground = data && typeof data.background === 'string' && data.background.trim() !== '';
    // 2. Формируем Data URL для 'background'
    const backgroundSrc = hasBackground ? `data:image/jpeg;base64,${data.background}` : '';

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        {title}
      </Typography>
      <Typography variant="body1" gutterBottom>
        {formatDateTime(eventRecord?.ts_start)}
      </Typography>

      <Stack spacing={3} sx={{ mb: 3 }}>
        {/* <TextField
          label={t('EventForm.registration_number')}
          value={eventRecord?.registration_number || ''}
          fullWidth
          InputProps={{
            readOnly: true,
          }}
        /> */}

      {/* <h3>Фон (Background)</h3> */}
      <img 
        src={backgroundSrc} 
        alt="Сгенерированный фон" 
        style={{ maxWidth: '100%', height: 'auto' }}
      />

      {/* <hr />

      <h3>{t('EventForm.Object')}</h3>
      <img 
        src={objectSrc} 
        alt="Сгенерированный объект" 
        style={{ maxWidth: '100%', height: 'auto' }} // Стили для отображения
      />

      <hr /> */}

      </Stack>
      <Box sx={{ mt: 3, display: 'flex', justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button onClick={onCancel} sx={{ mr: 1 }} 
          variant='outlined'>
            {t('OriginForm.Cancel')}
          </Button>
        </Box>
      </Box>
      
    </Box>
  );
};

export default EventForm;